import moment from "moment";
import React, { useEffect, useState } from "react";

const AdminGridColDef = ({ props_label, sortOrders, handleSort, CustomHeader, CustomTooltip, getMonthFromDate }) => {
  const [columnsDef, setColumnsDef] = useState([]);

  const formatDateInput = (date) => {
    if (!date) return "";
    return moment(date).format("MM/DD/YYYY");
  };

  let historyLables = [
    "Office Appointments",
    "Phone Appointments",
    "Virtual Appointments",
    "Reschedule Appointments",
    "Appointment Scheduled",
    "Life Insurance",
    "P&C",
    "Commercial/Farm",
    "Retirement",
    "Total Scheduled Appointments",
    "Opportunity",
    "Lead",
    "Thank You / Referrals",
    "Cross-Sell",
    "Commercial",
    "Re-Quote",
    "Win Back",
    "Event Call",



  ];

  const others_Labels = ["Call Attempts", "Not Interested", "Call Back Requested"]

  const coleDef = [
    {
      headerClass: "custom-ag-header",
      headerName: "Name",
      valueGetter: (params) => `${params.data.name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["name"] ? sortOrders["name"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "name",
        sortOrder: sortOrders && sortOrders["name"] ? sortOrders["name"] : null,
        handleSort,
      }),
      colId: "name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Phone",
      valueGetter: (params) => `${params.data.phone || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Phone"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "phone",
        sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
        handleSort,
      }),
      colId: "phone",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Agency",
      valueGetter: (params) => `${params.data.agency_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Agency"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Agency"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "agency_name",
        sortOrder: sortOrders["agency_name"],
        handleSort,
      }),
      colId: "agency_name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Type of Call",
      valueGetter: (params) => `${params.data.type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Type of Call"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_call",
        sortOrder: sortOrders["type_of_call"],
        handleSort,
      }),
      colId: "type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Sub Type",
      valueGetter: (params) => `${params.data.sub_type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Sub Type"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Sub Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "sub_type_of_call",
        sortOrder: sortOrders["sub_type_of_call"],
        handleSort,
      }),
      colId: "sub_type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Review Active Month",
      // valueGetter: (params) => `${params.data.rs_effective_date || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Review Active Month"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Review Active Month"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "rs_effective_date",
        sortOrder: sortOrders["rs_effective_date"],
        handleSort,
      }),
      colId: "rs_effective_date",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      valueGetter: (params) => {
        if (!params.data) return "";
        return getMonthFromDate(params.data.rs_effective_date);
      },
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Schedule By Date",
      // valueGetter: (params) => `${params.data.expiration_date || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Schedule By Date"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Schedule By Date"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "expiration_date",
        sortOrder: sortOrders["expiration_date"],
        handleSort,
      }),
      colId: "expiration_date",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      valueGetter: (params) => {
        if (!params.data) return "";
        return params.data.expiration_date
          ? moment(params.data.expiration_date).format("MM/DD/YYYY")
          : "-";
      },
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Who Created",
      valueGetter: (params) => `${params.data.who_created || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Who Created"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Who Created"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "who_created",
        sortOrder: sortOrders["who_created"],
        handleSort,
      }),
      colId: "who_created",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
  ];

  const coleDef_2 = [
    {
      headerClass: "custom-ag-header",
      headerName: "Name",
      valueGetter: (params) => `${params.data.agency_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["agency_name"] ? sortOrders["agency_name"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "agency_name",
        sortOrder: sortOrders && sortOrders["agency_name"] ? sortOrders["agency_name"] : null,
        handleSort,
      }),
      colId: "agency_name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Phone",
      valueGetter: (params) => `${params.data.phone || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Phone"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "phone",
        sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
        handleSort,
      }),
      colId: "phone",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Agency",
      valueGetter: (params) => `${params.data.agency_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Agency"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Agency"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "agency_name",
        sortOrder: sortOrders["agency_name"],
        handleSort,
      }),
      colId: "agency_name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Type of Call",
      valueGetter: (params) => `${params.data.type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Type of Call"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_call",
        sortOrder: sortOrders["type_of_call"],
        handleSort,
      }),
      colId: "type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Sub Type",
      valueGetter: (params) => `${params.data.sub_type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Sub Type"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Sub Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "sub_type_of_call",
        sortOrder: sortOrders["sub_type_of_call"],
        handleSort,
      }),
      colId: "sub_type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },

    {
      headerClass: "custom-ag-header",
      headerName: "Who Created",
      valueGetter: (params) => `${params.data.who_created || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Who Created"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Who Created"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "who_created",
        sortOrder: sortOrders["who_created"],
        handleSort,
      }),
      colId: "who_created",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },

  ];

  const coleDef_3 = [
    {
      headerClass: "custom-ag-header",
      headerName: "Name",
      valueGetter: (params) => `${params.data.full_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["full_name"] ? sortOrders["full_name"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "full_name",
        sortOrder: sortOrders && sortOrders["full_name"] ? sortOrders["full_name"] : null,
        handleSort,
      }),
      colId: "full_name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Phone",
      valueGetter: (params) => `${params.data.phone || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Phone"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "phone",
        sortOrder: sortOrders && sortOrders["phone"] ? sortOrders["phone"] : null,
        handleSort,
      }),
      colId: "phone",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Agency",
      valueGetter: (params) => `${params.data.agency_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Agency"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Agency"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "agency_name",
        sortOrder: sortOrders["agency_name"],
        handleSort,
      }),
      colId: "agency_name",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Type of Call",
      valueGetter: (params) => `${params.data.type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Type of Call"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_call",
        sortOrder: sortOrders["type_of_call"],
        handleSort,
      }),
      colId: "type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Sub Type",
      //   valueGetter: (params) => `${params.data.sub_type_of_call || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Sub Type"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Sub Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "sub_type_of_call",
        sortOrder: sortOrders["sub_type_of_call"],
        handleSort,
      }),
      colId: "sub_type_of_call",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      valueGetter: (params) => {
        if (props_label === "Phone Appointments" || props_label === "Virtual Appointments" || props_label === "Total Scheduled Appointments") {
          return `${(params.data && params.data.sub_types && params.data.sub_types[0] &&
            params.data.sub_types[0]['sub_type_of_call']) || ""}`
        }
        else {
          return `${params.data.sub_type_of_call || ""}`
        }
      }
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Appointment Date",
      // valueGetter: (params) => `${params.data.rs_effective_date || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Appointment Date"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Appointment Date"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "appointment_date",
        sortOrder: sortOrders["appointment_date"],
        handleSort,
      }),
      colId: "appointment_date",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      valueGetter: (params) => {
        if (!params.data) return "";
        return formatDateInput(params.data.appointment_date);
      },
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Scheduled With",
      valueGetter: (params) => `${params.data.who_created || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Scheduled With"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Scheduled With"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "expiration_date",
        sortOrder: sortOrders["expiration_date"],
        handleSort,
      }),
      colId: "expiration_date",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      //   valueGetter: (params) => {
      //     if (!params.data) return "";
      //     return params.data.expiration_date
      //       ? moment(params.data.expiration_date).format("MM/DD/YYYY")
      //       : "-";
      //   },
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Who Created",
      valueGetter: (params) => `${params.data.who_created || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["Who Created"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Who Created"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "who_created",
        sortOrder: sortOrders["who_created"],
        handleSort,
      }),
      colId: "who_created",
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
  ];


  useEffect(() => {
    console.log("label check", props_label)
    if (others_Labels.includes(props_label)) {
      setColumnsDef(coleDef_2)
    } else if (historyLables.includes(props_label)) {
      setColumnsDef(coleDef_3)
    }
    else {
      setColumnsDef(coleDef)
    }
  }, [props_label]);

  return columnsDef
};

export default AdminGridColDef;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/AdminGridColDef.js